import { render, staticRenderFns } from "./SideForm.vue?vue&type=template&id=46ba9e15&"
import script from "./SideForm.vue?vue&type=script&lang=js&"
export * from "./SideForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports